export const session = {
  state: {
    timeToExpire: 60,
    showAlert: false,
    timerReference: null
  },
  reducers: {
    updateTimeToExpire(state, payload) {
      return { ...state, timeToExpire: payload };
    },
    updateShowAlert(state, payload) {
      return { ...state, showAlert: payload };
    },
    updateTimerReference(state, payload) {
      return { ...state, timerReference: payload };
    }
  }
};